import { useEffect } from 'react';
import { useHistory, useLocation, useParams } from 'react-router';

import { Environment } from '@playq/octopus-common';

/**
 * Ensures that the current route contains the `env` parameter (`Live` or `Sandbox`).
 * If not present, it automatically replaces the current path with the default env value.
 *
 * Useful for routes that rely on environment context but don't enforce it in the URL structure.
 *
 * @returns { env } - The current environment extracted from route params.
 */
export const useSyncEnvWithPath = (): { env: Environment } => {
  const { env = Environment.Live } = useParams<{ env: Environment }>();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    const hasEnvInPath = location.pathname.match(/\/(Live|Sandbox)(\/|$)/);
    if (!hasEnvInPath) {
      history.replace(env);
    }
  }, [env, history, location.pathname]);
  return { env };
};
